import { Places } from '../../../../route-consts';
import { CollaboratorsKeys } from '../collaborators.key';
/**
 * A LISTAGEM de colaboradores.
 *
 * Nao declara parametro proprio: o filtro, a ordenacao e a pagina pertencem ao
 * CONCEITO, e ela os consome por heranca - a listagem esta mais fundo no mesmo
 * caminho. O que esta classe acrescenta e o place, e so.
 *
 * O detalhe estende a mesma base, e por isso as duas telas veem o mesmo filtro sem
 * que uma dependa da outra. Antes o detalhe estendia a LISTAGEM, o que obrigava a
 * listagem a ser ancestral dele.
 */
export class CollaboratorListKeys extends CollaboratorsKeys {
    get place() {
        return Places.collaboratorList;
    }
}
//# sourceMappingURL=collaborator-list.key.js.map